<template>
    <div>
        <AboutUsTop />
        <div class="titleStyle">
            <div class="titleFont">企业概况</div>
            <div class="conentFont">
                <div class="divide"></div>
                <span class="enFont">ENTERPRICE OVERVIEW</span>
                <div class="divide"></div>
            </div>
        </div>
        <div class="describeFont">
            <div>建华物流集团成立于2003年，注册资金1.4亿元，是国家5A级物流企业、国家3A级综合信用评级企业、江苏省重点物流企业、江苏省优秀企业，名列中国物流企业50强、中国民营物流企业50强，荣获“五星级车队”、“改革开放四十年智慧物流特别贡献单位”等称号。 集团总部位于江苏镇江，在全国20多个省、市、自治区及直辖市建立了80余家全资子公司，建成了覆盖全球的物流服务网络，为客户提供专业、高效的供应链一体化服务。</div>
            <div>集团员工超4500人，年货运量超1.5亿吨，目前拥有重型牵引车、自卸车、罐车等4000余辆，仓储能力80万平米，可控外协车辆20000余辆、吊机合作商1000余家。集团自有千吨级码头7座，在长江、珠江、近海及东南亚国家航运资源均拥有成熟的航运资源，目前拥有300余艘自有船运力，合作管控3000余艘稳定的船运力，年吞吐量达5000余万吨。</div>
            <div>建华物流拥有大件运输资质、电力运输资质、无车、无船承运资质，在水、陆、空、铁等多式联运方面具备成熟的方案设计及运营能力，多个重点项目入选江苏省多式联运示范工程，致力于成为大宗与建材领域综合物流服务商。</div>
<!--            <div>{{ dataList.description }}</div>-->
        </div>
        <div class="organizational">
            <div class="titleStyle">
                <div class="titleFont">组织架构</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">ORGANIZATIONAL STRUCTURE</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="companyProfileBottom">
                <img :src="dataList.image" class="companyProfileBottomImg" />
            </div>
        </div>
    </div>
</template>
<script>
import AboutUsTop from "@/components/AboutUsTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "CompanyProfile",
    components: {
        AboutUsTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryAboutusList",
            dataList: {},
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 80,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    that.dataList = res.result.records[0];
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.describeFont {
    .typeArea();
    text-indent: 2em;
    padding: 0 50px;
    font-size: 18px;
    letter-spacing: 1.1px;
    line-height: 1.6em;
    color: #333333;
    margin-bottom: 120px;

}
.organizational {
    background: #fbfbfb;
    .companyProfileBottom {
        .companyProfileBottomImg {
            width: 100%;
        }
    }
}
</style>
